export const host = "https://leichanzi.com";
export const apiHost = "https://leichanzi.com"